/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BackgroundColorPickerContainer_user$ref: FragmentReference;
export type BackgroundColorPickerContainer_user = {|
  +backgroundColor: ?string,
  +$refType: BackgroundColorPickerContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "BackgroundColorPickerContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "backgroundColor",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '0b3763d486015259bac7483f15964188';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Background/__generated__/BackgroundColorPickerContainer_user.graphql.js